enum BatchJobType {
    Recurring = 'Recurring',
    OneTime = 'OneTime',
}

export default BatchJobType;
